import { render, staticRenderFns } from "./MailItem.vue?vue&type=template&id=7a2eaf48"
import script from "./MailItem.vue?vue&type=script&lang=js"
export * from "./MailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports